document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('.menu-button');
  const nav = document.querySelector('#MobileNav');
  menuButton?.addEventListener('click', () => {
    const open = menuButton.getAttribute('aria-expanded') === 'true';
    menuButton.setAttribute('aria-expanded', String(!open));
    nav?.classList.toggle('open', !open);
  });

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const variantsNode = section.querySelector('[data-product-json]');
    const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    const idInput = section.querySelector('[data-variant-id]');
    const price = section.querySelector('[data-price]');
    const compare = section.querySelector('[data-compare-price]');
    const addButton = section.querySelector('[data-add-button]');
    const addText = section.querySelector('[data-add-text]');
    const moneyFormat = window.Shopify?.currency?.active || '';
    const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: moneyFormat || 'USD' }).format(cents / 100);

    const updateVariant = () => {
      const selected = Array.from(section.querySelectorAll('[data-option-index]')).map((fieldset) => fieldset.querySelector('input:checked')?.value);
      const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
      if (!variant) {
        addButton.disabled = true;
        addText.textContent = 'UNAVAILABLE';
        return;
      }
      idInput.value = variant.id;
      price.textContent = formatMoney(variant.price);
      if (variant.compare_at_price > variant.price) {
        compare.hidden = false;
        compare.textContent = formatMoney(variant.compare_at_price);
      } else {
        compare.hidden = true;
      }
      addButton.disabled = !variant.available;
      addText.textContent = variant.available ? 'BUY NOW' : 'SOLD OUT';
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };
    section.querySelectorAll('[data-option-index] input').forEach((input) => input.addEventListener('change', updateVariant));

    section.querySelector('[data-buy-now]')?.addEventListener('click', async (event) => {
      event.preventDefault();
      const button = event.currentTarget;
      if (button.disabled) return;
      button.disabled = true;
      addText.textContent = 'LOADING…';
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] })
        });
        if (!response.ok) throw new Error('Unable to add item');
        window.location.href = '/checkout';
      } catch (error) {
        button.disabled = false;
        addText.textContent = 'TRY AGAIN';
      }
    });

    const mediaNode = section.querySelector('[data-product-media]');
    const media = mediaNode ? JSON.parse(mediaNode.textContent) : [];
    const mainImage = section.querySelector('[data-main-media] img');
    section.querySelectorAll('[data-media-button]').forEach((button, index) => button.addEventListener('click', () => {
      const item = media.find((entry) => String(entry.id) === button.dataset.mediaId);
      if (item && mainImage) {
        mainImage.src = item.src;
        mainImage.alt = item.alt;
        section.querySelectorAll('[data-media-button]').forEach((thumb) => thumb.classList.remove('active'));
        button.classList.add('active');
        const counter = section.querySelector('.image-number');
        if (counter) counter.textContent = `${index + 1} / ${media.length}`;
      }
    }));
  });

  document.querySelectorAll('[data-reviews]').forEach((wrapper) => {
    const slides = Array.from(wrapper.querySelectorAll('[data-review-slide]'));
    const counter = wrapper.querySelector('[data-review-counter]');
    let index = 0;
    const show = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => slide.classList.toggle('is-hidden', slideIndex !== index));
      if (counter) counter.textContent = `${index + 1} / ${slides.length}`;
    };
    wrapper.querySelector('[data-review-prev]')?.addEventListener('click', () => show(index - 1));
    wrapper.querySelector('[data-review-next]')?.addEventListener('click', () => show(index + 1));
  });
});
